import { BlockOrdering } from "./BlockOrdering";

export enum ShapeType {
    Unknown = 0,

    Square,

    TriangleNE,
    TriangleNW,
    TriangleSE,
    TriangleSW
}

/*export enum BlockOrdering {
    // Must always be 0 since this was the initial implementation.
    //
    // Later the other orderings were added.
    Alternate = 0,
    Row,
    Column
}*/

export interface IBlockShape {
    readonly x: number;
    readonly y: number;
    readonly colorIndex: number;

    readonly type: ShapeType;
}

export interface IBlock {
    readonly size: number;

    // If >= 0, block background color index.
    readonly backgroundColorIndex: number;

    readonly shapes: IBlockShape[];

    readonly sourceUrl: string;
}

export interface IColorRGB {
    readonly r: number;
    readonly g: number;
    readonly b: number;
}


export interface IQuiltRenderData {
    readonly code: string;

    readonly rows: number;
    readonly columns: number;
    
    readonly backgroundColor: IColorRGB;
    
    readonly paddingWidth: number;
    readonly paddingHeight: number;
    
    readonly blockOrdering: BlockOrdering;
    readonly blockSize: number;
    readonly blockPaddingWidth: number;
    readonly blockPaddingHeight: number;
    
    readonly blockColorOffset: number;
    readonly blocks: IBlock[]
    readonly blockColors: IColorRGB[];
}